import { render, staticRenderFns } from "./CandidateItemPipeline.vue?vue&type=template&id=19ef530e&scoped=true"
import script from "./CandidateItemPipeline.vue?vue&type=script&lang=js"
export * from "./CandidateItemPipeline.vue?vue&type=script&lang=js"
import style0 from "./CandidateItemPipeline.vue?vue&type=style&index=0&id=19ef530e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ef530e",
  null
  
)

export default component.exports